import React, { useState } from 'react';
import axios from '../axios';
import config from '../config';
import { useHistory } from 'react-router-dom';
import heartImage from '../logo192.png';
import stethoscopeImage from '../stethoscope.webp';
import { Link } from 'react-router-dom';
import './RegisterForm.css';
import { useLanguage } from '../i18n/LanguageContext';

const RegisterForm = ({ onLogin }) => {
    const backend_url = config.backend_url;
    const [formData, setFormData] = useState({ 
        username: '', 
        password: '', 
        user_type: 'seller', 
        email: '',
        firstname: '',
        lastname: ''
    });
    const [message, setMessage] = useState('');
    const history = useHistory();
    const { t } = useLanguage();

    const handleChange = (event) => {
        setFormData({ ...formData, [event.target.name]: event.target.value });
    };

    const handleSubmit = async (event) => {
        event.preventDefault();
        try {
            const registerResponse = await axios.post(`${backend_url}/api/register`, formData, { withCredentials: true });
            setMessage(registerResponse.data.message);

            if (registerResponse.status === 200) {
                // Attempt to login the user after registration
                const loginResponse = await axios.post(`${backend_url}/api/login`, {
                    username: formData.username,
                    password: formData.password,
                }, { withCredentials: true });

                if (loginResponse.status === 200) {
                    const { user_type, user_id, token, firstname, lastname } = loginResponse.data;
                    
                    // Store the token in localStorage as a fallback authentication method
                    if (token) {
                        localStorage.setItem('authToken', token);
                        // Set the token in axios default headers for all future requests
                        axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
                    }
                    
                    // Store the user's name for easy access
                    if (firstname) localStorage.setItem('firstname', firstname);
                    if (lastname) localStorage.setItem('lastname', lastname);
                    
                    onLogin(user_type, user_id);
                    // Redirect to object-form with direct workflow for sellers, home for brokers
                    if (user_type === 'seller') {
                        history.push('/object-form?workflow=direct');
                    } else {
                        history.push('/');
                    }
                } else {
                    setMessage(t('auth.autoLoginFailed'));
                }
            }
        } catch (error) {
            console.error(error.response);
            setMessage(`Error: ${error.response?.data?.message || t('auth.registrationFailed')}`);
        }
    };

    return (
        <div className="register-form-container">
            <div className="register-header">
                <img src={heartImage} alt="Heart" style={{ display: 'none', marginRight: '20px' }} />
                <h1>{t('auth.registerTitle')}</h1>
                <img src={stethoscopeImage} alt="Stethoscope" style={{ display: 'none', marginLeft: '20px' }} />
            </div>
            
            <div className="form-content">
                <form onSubmit={handleSubmit}>
                    <div className="form-group">
                        <label htmlFor="firstname">{t('auth.firstName')}:</label>
                        <input 
                            type="text" 
                            id="firstname" 
                            name="firstname" 
                            value={formData.firstname} 
                            onChange={handleChange} 
                        />
                    </div>
                    
                    <div className="form-group">
                        <label htmlFor="lastname">{t('auth.lastName')}:</label>
                        <input 
                            type="text" 
                            id="lastname" 
                            name="lastname" 
                            value={formData.lastname} 
                            onChange={handleChange} 
                        />
                    </div>
                    
                    <div className="form-group">
                        <label htmlFor="username">{t('auth.username')}:</label>
                        <input 
                            type="text" 
                            id="username" 
                            name="username" 
                            value={formData.username} 
                            onChange={handleChange} 
                            required
                        />
                    </div>
                    
                    <div className="form-group">
                        <label htmlFor="password">{t('auth.password')}:</label>
                        <input 
                            type="password" 
                            id="password" 
                            name="password" 
                            value={formData.password} 
                            onChange={handleChange} 
                            required
                        />
                    </div>
                    
                    <div className="form-group" style={{ display: 'none' }}>
                        <label htmlFor="email">{t('common.email')}:</label>
                        <input 
                            type="email" 
                            id="email" 
                            name="email" 
                            value={formData.email} 
                            onChange={handleChange} 
                        />
                    </div>
                    
                    <div className="form-group">
                        <label htmlFor="user_type">{t('auth.userType')}:</label>
                        <select 
                            id="user_type" 
                            name="user_type" 
                            value={formData.user_type} 
                            onChange={handleChange}
                            className="form-select"
                        >
                            <option value="seller">{t('auth.seller')}</option>
                            <option value="broker">{t('auth.broker')}</option>
                        </select>
                    </div>
                    
                    <div className="button-container">
                        <button type="submit" className="primary-button">{t('auth.registerButton')}</button>
                        <Link to="/" style={{ textDecoration: 'none' }}>
                            <button type="button" className="secondary-button">{t('common.home')}</button>
                        </Link>
                    </div>
                </form>
                
                {message && <p className="message">{message}</p>}
            </div>
        </div>
    );
};

export default RegisterForm;
